import dayjs from "dayjs";

export function formatTime(timestamp, formatString = "MMM DD, YYYY, HH:mm") {
  const date = new Date(Number(timestamp));
  return dayjs(date).format(formatString);
}
